import { Button, PageHeader } from 'components';
import { Form, Upload, Select, Typography, Table, Col, Row } from 'antd';
import styles from './style.module.scss';
import { ImportOutlined, InboxOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import useFootfalls from '../useFootfalls';
import FormHelper from '../../../../../helpers/FormHelper';
import React from 'react';

const { Option } = Select;

const Import = () => {
  const { t } = useTranslation();
  const { shoppingCenters, handleImportExcel, form } = useFootfalls(false);
  const onFinish = async (values) => {
    await handleImportExcel(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={t('IMPORTA FOOTFALL')}>
        <Button
          width={'150px'}
          onClick={handleCreate}
          big
          icon={<ImportOutlined />}
        >
          {t('IMPORT')}
        </Button>
      </PageHeader>
      <div className={styles.content}>
        <Card>
          <Form
            form={form}
            name='basic'
            wrapperCol={{ span: 8 }}
            initialValues={{
              shopping_center_id: '',
            }}
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            autoComplete='off'
          >
            <Form.Item
              label={t('Outlet Village')}
              name={'shopping_center_id'}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 8 }}
              labelAlign={'left'}
            >
              <Select
                placeholder={t('Outlet Village')}
                style={{ width: '100%' }}     
              >
                {shoppingCenters.map((i) => (
                  <Option key={i.id} value={i.id}>
                    {i.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label='File'
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 8 }}
              labelAlign={'left'}
            >
              <Form.Item
                name='file'
                valuePropName='fileList'
                getValueFromEvent={FormHelper.normFile}
                noStyle
                multiple={false}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Upload.Dragger
                  multiple={false}
                  name='file'
                  beforeUpload={FormHelper.beforeUpload}
                >
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>
                    {t('Clicca o trascina il file da importare')}
                  </p>
                  <p className='ant-upload-hint'>
                    {t('Support for a single or bulk upload.')}
                  </p>
                </Upload.Dragger>
              </Form.Item>
            </Form.Item>
          </Form>
          <Col span={24}>
            <Typography>{t('Esempio')}</Typography>
            <br />
            <Row>
              <Col span={8}>
                <Table
                  pagination={false}
                  columns={[
                    {
                      title: t('Giorno'),
                      dataIndex: 'invoice_date',
                    },
                    {
                      title: t('Visitatori'),
                      dataIndex: 'visitors',
                    },
                  ]}
                  dataSource={[
                    {
                      invoice_date: '2021-04-14',
                      visitors: 100,
                    },
                    {
                      invoice_date: '06 giugno 2022',
                      visitors: 100,
                    },
                    {
                      invoice_date: '06/giugno/2022',
                      visitors: 100,
                    },
                    {
                      invoice_date: '06/april/2022',
                      visitors: 100,
                    },
                    {
                      invoice_date: '06 april 2022',
                      visitors: 100,
                    },
                    {
                      invoice_date: '06/10/2022',
                      visitors: 100,
                    },
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Card>
      </div>
    </div>
  );
};

export default Import;
